export const frenchTranslations: Record<string, string> = {
  // Navigation
  'nav.home': 'Accueil',
  'nav.shop': 'Nos produits',
  'nav.about': 'A propos',
  'nav.contact': 'Contact',
  'nav.blog': 'Blog',
  'nav.trackOrder': 'Suivre ma commande',

  // Hero
  'hero.badge.pdrn': 'Technologie PDRN',
  'hero.badge.glassSkin': 'Effet Glass Skin',
  'hero.badge.korean': 'Innovation coréenne',
  'hero.title': 'Soin PDRN — DNA de saumon coréen',
  'hero.subtitle': 'Transformez votre peau avec nos sérums PDRN, masques en tissu et crèmes capsules cliniquement prouvés. Obtenez l’effet Glass Skin avec nos soins PDRN premium à base de DNA de saumon.',
  'hero.cta': 'Découvrez la collection',
  'hero.ctaSurvey': 'Diagnostic de peau gratuit',
  'hero.socialProof': 'Adoré par plus de 10 000 passionnées de soins',
  'survey.bubbleTooltip': 'Routine personnalisée + 10% de réduction',

  // Products
  'products.title': 'Notre collection',
  'products.subtitle': 'Soins coréens premium à la technologie PDRN',
  'products.addToCart': 'Ajouter au panier',
  'products.buyNow': 'Acheter maintenant',
  'products.soldOut': 'Épuisé',
  'products.save': 'Promo',
  'products.viewDetails': 'Détails',
  'products.noProducts': 'Aucun produit disponible actuellement',
  'products.selectSize': 'Choisir la taille',
  'products.quantity': 'Quantité',
  'products.inStock': 'En stock',
  'products.outOfStock': 'Épuisé',

  // Upsell
  'upsell.title': 'Complétez votre routine',
  'upsell.savings': 'Économisez avec le coffret complet',
  'upsell.cta': 'Passez au coffret complet',
  'upsell.includes': 'Une routine complète en un seul coffret',
  'upsell.badge': 'Complétez votre routine',
  'upsell.saveBadge': 'Économisez {amount} !',
  'upsell.whyBundle': 'Pourquoi choisir le coffret complet ?',
  'upsell.whyBundleDesc': 'Chaque étape renforce la précédente pour des résultats optimaux',
  'upsell.includesSerum': 'Sérum éclat rosé',
  'upsell.includesCream': 'Crème capsules intelligente',
  'upsell.includesMasks': 'Coffret de 10 masques',
  'upsell.separatelyPrice': 'Séparément : {amount}',
  'upsell.serumTooltip': 'Sérum PDRN léger qui stimule la production de collagène, lisse les rides et offre un éclat Glass Skin immédiat.',
  'upsell.creamTooltip': 'Formule capsule innovante avec PDRN, 5% de niacinamide et collagène hydrolysé pour une hydratation profonde et une peau raffermie.',
  'upsell.masksTooltip': '10 masques en tissu imbibés de sérum PDRN concentré pour un soin intensif offrant un effet Glass Skin immédiat.',

  // Cart
  'cart.title': 'Panier',
  'cart.empty': 'Votre panier est vide',
  'cart.itemCount': '{count} articles dans le panier',
  'cart.total': 'Total',
  'cart.checkout': 'Passer à la caisse',
  'cart.continueShopping': 'Continuer vos achats',
  'cart.addedToCart': 'Ajouté au panier !',
  'cart.couponPlaceholder': 'Code de réduction',
  'cart.applyCoupon': 'Appliquer',
  'cart.couponApplied': 'Réduction appliquée !',
  'cart.couponError': 'Code invalide',
  'cart.removeCoupon': 'Supprimer',
  'cart.freeShippingUnlocked': 'Livraison gratuite débloquée !',
  'cart.freeShippingRemaining': 'Ajoutez encore {amount} pour la livraison gratuite',
  'cart.freeShippingThreshold': 'Livraison gratuite pour les commandes de plus de {amount}',
  'cart.completeRoutine': 'Complétez votre routine',
  'cart.bundleSave': 'Économisez {percent}%',
  'cart.quickAdd': 'Ajouter',

  'promo.b2g1': '🎁 Ajoutez 3 articles au panier — 1 est GRATUIT !',
  'promo.b2g1Cart': '🎁 Offre 2+1 appliquée ! Pour 3 articles, 1 est GRATUIT !',
  'promo.b2g1CartHint': 'Ajoutez {count} de plus pour un produit GRATUIT ! (3 articles requis)',
  'promo.b2g1Saving': 'Vous économisez {amount} — l\'article le moins cher est GRATUIT !',
  'promo.freeItem': '🎁 GRATUIT en promo',

  // About
  'about.title': 'À propos',
  'about.subtitle': 'La science derrière la beauté coréenne',
  'about.pdrnTitle': 'La science du soin PDRN',
  'about.pdrnDescription': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — un ingrédient révolutionnaire des soins coréens. Nos produits PDRN favorisent la régénération cellulaire pour un effet Glass Skin parfait.',
  'about.glassSkinDesc': 'Obtenez l’effet Glass Skin coréen tant recherché avec un éclat immédiat.',
  'about.hydrationDesc': 'Hydratation profonde qui dure toute la journée, avec une rétention d’hydratation cliniquement prouvée.',
  'about.antiAgingDesc': 'Stimulez naturellement la production de collagène pour une peau plus ferme et plus jeune.',

  // Footer
  'footer.copyright': '© 2026 PDRN SKIN. Tous droits réservés.',
  'footer.freeShipping': 'Livraison gratuite dès {amount} (France)',
  'footer.securePayment': 'Paiement sécurisé',
  'footer.support': 'Assistance 24h/24 7j/7',
  'footer.description': 'Soins coréens premium à la technologie PDRN révolutionnaire. Découvrez l’effet Glass Skin avec nos produits scientifiques.',
  'footer.sheetMasks': 'Masques en tissu',
  'footer.serum': 'Sérum',
  'footer.cream': 'Crème',
  'footer.bundle': 'Coffret complet',
  'footer.faq': 'Questions fréquentes',
  'footer.shippingReturns': 'Livraison et retours',
  'footer.privacyPolicy': 'Politique de confidentialité',
  'footer.termsOfService': 'Conditions générales',
  'footer.returnPolicy': 'Politique de retour',
  'footer.contactSupport': 'Nous sommes à votre disposition pour toute question, suivi de commande, problème ou aide à l\'achat. Contactez notre service client à',

  // Common
  'common.verified': 'Vérifié',
  'common.before': 'Avant',
  'common.after': 'Après',
  'common.loading': 'Chargement...',
  'common.error': 'Une erreur est survenue',
  'common.noPhotoShared': 'La cliente n’a pas partagé de photo',

  // Media
  'media.videoPlaceholder': 'Espace réservé pour la vidéo',
  'media.gifPlaceholder': 'Espace réservé pour le GIF',
  'media.imagePlaceholder': 'Espace réservé pour l’image',

  // Features
  'feature.hydration': '+100% d’hydratation',
  'feature.glassSkin': 'Effet Glass Skin',
  'feature.antiAging': 'Anti-âge',
  'feature.collagen': 'Boost de collagène',
  'feature.brightening': 'Éclat',

  // Product
  'product.howToUse': 'Mode d’emploi',
  'product.ingredients': 'Ingrédients clés',
  'product.reviews': 'Avis clients',
  'product.results': 'Résultats réels',
  'product.realResults': 'Résultats réels',
  'product.beforeAfter': 'Avant et après',
  'product.faqTitle': 'Questions et réponses',
  'product.mediaGallery': 'Galerie média',
  'product.freeShipping': 'Livraison gratuite dès {amount}',
  'product.secureCheckout': 'Paiement sécurisé',
  'product.returns': 'Retour sous 7 jours',
  'product.koreanFormula': 'Formule coréenne',
  'product.premiumIngredients': 'Ingrédients premium',
  'product.backHome': 'Retour à l’accueil',
  'product.notFound': 'Produit introuvable',
  'product.bestValue': 'Meilleur rapport qualité-prix',
  'product.bestseller': 'Best-seller',
  'product.reviewCount': '({count} avis)',
  'product.crueltyFree': 'Non testé sur les animaux',
  'product.youMayAlsoLike': 'Vous aimerez aussi',
  'product.completeRoutine': 'Complétez votre routine de soins',
  'product.moneyBack': 'Remboursement sous 7 jours',
  'product.dermatologistTested': 'Testé dermatologiquement',
  'product.payWith': 'Paiement sécurisé via',
  'product.specsTitle': 'Détails du produit',
  'product.specsVolume': 'Contenance',
  'product.specsSkinType': 'Type de peau',
  'product.specsTested': 'Tests',
  'product.specsClinicallyTested': 'Testé cliniquement',
  'product.specsShelfLife': 'Durée de conservation',
  'product.specsFreeOf': 'Sans parabènes, sulfates ni phtalates',
  'product.satisfactionGuarantee': 'Garantie 100% satisfaction',
  'product.satisfactionDesc': 'Essayez sans risque avec notre garantie de remboursement sous 7 jours',

  // Before After
  'beforeAfter.customer1': 'Camille',
  'beforeAfter.customer2': 'Léa',
  'beforeAfter.customer3': 'Fatou',
  'beforeAfter.weeks3': '3 semaines d’utilisation',
  'beforeAfter.weeks8': '8 semaines d’utilisation',
  'beforeAfter.weeks12': '12 semaines d’utilisation',

  // Mobile Cart
  'mobileCart.findRoutine': 'Trouvez votre routine',

  // Survey
  'survey.buttonText': 'Trouvez votre routine',
  'survey.title': 'Diagnostic de peau',
  'survey.subtitle': 'Répondez à quelques questions et nous vous recommanderons la routine idéale',
  'survey.question': 'Question',
  'survey.back': 'Retour',
  'survey.next': 'Suivant',
  'survey.getResults': 'Voir les résultats',
  'survey.resultsTitle': 'Votre routine personnalisée',
  'survey.resultsSubtitle': 'D’après vos réponses, voici ce que nous vous recommandons',
  'survey.yourProfile': 'Votre profil de peau',
  'survey.recommended': 'Recommandé pour vous',
  'survey.bundleNote': 'Pour de meilleurs résultats, nous vous recommandons le coffret complet',
  'survey.howToUse': 'Votre routine personnalisée',
  'survey.morning': 'Matin',
  'survey.evening': 'Soir',
  'survey.expectedResults': 'Résultats attendus',
  'survey.week': 'semaine',
  'survey.weeks': 'semaines',
  'survey.personalTips': 'Nos conseils pour vous',
  'survey.retake': 'Recommencer',
  'survey.shopNow': 'Acheter maintenant',
  'survey.errorTooMany': 'Trop de requêtes. Veuillez réessayer plus tard.',
  'survey.errorGeneric': 'Une erreur est survenue. Veuillez réessayer.',
  'survey.yourPersonalizedRoutine': 'Votre routine personnalisée',
  'survey.treatmentPlan': 'Durée de traitement recommandée',
  'survey.addRoutineToCart': 'Ajouter la routine au panier',
  'survey.satisfactionGuarantee': 'Garantie 100% satisfaction',
  'survey.maybeLater': 'Peut-être plus tard',
  'survey.continueSurvey': 'Continuer le questionnaire',
  'survey.addedToCart': 'Les produits ont été ajoutés au panier !',
  'survey.personalizedRoutine': 'Votre routine personnalisée est prête',
  'survey.errorAddingToCart': 'Erreur lors de l’ajout au panier',
  'survey.exclusiveDiscount': '10% de réduction exclusive pour vous !',
  'survey.couponCopied': 'Code promo copié !',
  'survey.useAtCheckout': 'Utilisez le code SURVEY10 lors du paiement pour obtenir 10% de réduction',
  'survey.bestDeal': 'La meilleure offre que nous avons trouvée pour vous !',
  'survey.separatePrice': 'Séparément',
  'survey.yourPrice': 'Votre prix',
  'survey.youSave': 'Vous économisez',
  'survey.upgradeOption': 'Vous souhaitez des résultats encore meilleurs ?',
  'survey.upgradeToBundle': 'Passer au coffret complet',
  'survey.upgradeSave': 'Économisez {amount} avec le coffret complet',
  'survey.addSingleToCart': 'Ajouter au panier',

  // Survey loading messages
  'survey.loading.analyzing': 'Analyse de votre profil de peau...',
  'survey.loading.planning': 'Création d’un traitement personnalisé...',
  'survey.loading.matching': 'Sélection des produits idéaux pour vous...',
  'survey.loading.finalizing': 'Presque prêt...',

  // Survey questions
  'survey.q1.question': 'Quel est votre type de peau ?',
  'survey.q1.dry': 'Sèche — ma peau tiraille souvent',
  'survey.q1.oily': 'Grasse — brillante, surtout sur le front et le nez',
  'survey.q1.combination': 'Mixte — front et nez gras, joues sèches',
  'survey.q1.normal': 'Normale — équilibrée, sans problème majeur',
  'survey.q2.question': 'Quelle est votre préoccupation principale ?',
  'survey.q2.aging': 'Rides et ridules',
  'survey.q2.acne': 'Acné et imperfections',
  'survey.q2.dullness': 'Teint terne et irrégulier',
  'survey.q2.hyperpigmentation': 'Taches brunes et hyperpigmentation',
  'survey.q3.question': 'Votre peau est-elle sensible ?',
  'survey.q3.very': 'Très sensible — réagit à la plupart des produits',
  'survey.q3.somewhat': 'Moyennement sensible — réactions occasionnelles',
  'survey.q3.not': 'Pas sensible — tolère la plupart des produits',
  'survey.q4.question': 'Quel est le niveau d’hydratation de votre peau ?',
  'survey.q4.veryDry': 'Très sèche — besoin constant d’hydratation',
  'survey.q4.somewhatDry': 'Plutôt sèche — besoin régulier d’hydratation',
  'survey.q4.balanced': 'Équilibrée — ni sèche ni grasse',
  'survey.q4.wellHydrated': 'Bien hydratée — ferme et saine',
  'survey.q5.question': 'Quelle est votre tranche d’âge ?',
  'survey.q5.under25': 'Moins de 25 ans',
  'survey.q5.25to35': '25-35 ans',
  'survey.q5.35to45': '35-45 ans',
  'survey.q5.over45': 'Plus de 45 ans',
  'survey.q6.question': 'Comment décririez-vous votre routine de soins actuelle ?',
  'survey.q6.minimal': 'Minimale — nettoyage et hydratation uniquement',
  'survey.q6.basic': 'Basique — nettoyage, tonique, hydratation',
  'survey.q6.moderate': 'Modérée — inclut sérums et soins ciblés',
  'survey.q6.extensive': 'Complète — routine de soin coréenne complète',
  'survey.q7.question': 'Comment décririez-vous la texture de votre peau ?',
  'survey.q7.smooth': 'Lisse et uniforme',
  'survey.q7.rough': 'Rugueuse et texturée',
  'survey.q7.uneven': 'Irrégulière avec quelques relèvements',
  'survey.q7.bumpy': 'Granuleuse avec des pores visibles',
  'survey.q8.question': 'Quel est votre objectif principal en matière de soins ?',
  'survey.q8.glow': 'Obtenir l’éclat Glass Skin coréen',
  'survey.q8.antiAging': 'Réduire les signes de l’âge',
  'survey.q8.hydration': 'Hydratation profonde',
  'survey.q8.all': 'Tout ce qui précède',

  // Trust Strip
  'trust.clinicallyTested': 'Testé cliniquement',
  'trust.happyCustomers': 'Plus de 10 000 clientes satisfaites',
  'trust.labFormula': 'Formule de laboratoire coréen',
  'trust.moneyBack': 'Remboursement sous 7 jours',

  // Science
  'science.title': 'PDRN issu du DNA de saumon — validé scientifiquement',
  'science.subtitle': 'Le PDRN est cliniquement prouvé par des études évaluées par des pairs',
  'science.citation1': '« Le PDRN favorise la cicatrisation et la régénération tissulaire via l’activation du récepteur d’adénosine A2A. »',
  'science.source1': '— Journal of Cosmetic Dermatology, 2020',
  'science.citation2': '« Le PDRN d’origine saumon améliore significativement l’hydratation, l’élasticité et réduit la profondeur des rides lors d’essais cliniques. »',
  'science.source2': '— International Journal of Molecular Sciences, 2021',

  // Science Inside
  'scienceInside.title': 'La science à l’intérieur',
  'scienceInside.subtitle': 'Pourquoi cette formule fonctionne — deux moteurs puissants dans un seul sérum',
  'scienceInside.peptides.title': 'Peptides — les ingénieurs',
  'scienceInside.peptides.subtitle': '« Des messagers intelligents, pas une crème miracle »',
  'scienceInside.peptides.point1': 'Courtes chaînes d’acides aminés qui signalent à votre peau de se comporter comme une peau jeune et renouvelée',
  'scienceInside.peptides.point2': 'Soutien d’une apparence plus ferme et de ridules moins visibles au fil du temps',
  'scienceInside.peptides.point3': 'Renforcent la barrière cutanée — la peau paraît moins fragile et moins réactive',
  'scienceInside.peptides.point4': 'Effet intelligent qui s’intensifie avec une utilisation régulière, pas un miracle d’un jour',
  'scienceInside.pdrn.title': 'PDRN — le réparateur',
  'scienceInside.pdrn.subtitle': 'L’ingrédient de réparation phare du monde K-Beauty',
  'scienceInside.pdrn.point1': 'Fragments de DNA qui parlent le langage de la régénération et de la réparation',
  'scienceInside.pdrn.point2': 'Soutient la qualité de la peau et favorise une apparence saine et dense',
  'scienceInside.pdrn.point3': 'Apaise les peaux stressées ou réactives — moins de rougeurs, plus d’équilibre',
  'scienceInside.pdrn.point4': 'Dans le sérum : amélioration progressive et intelligente — pas de résultat spectaculaire du jour au lendemain',
  'scienceInside.combo.title': 'Deux moteurs, un seul sérum',
  'scienceInside.combo.subtitle': 'Éclat immédiat + anti-âge cumulatif',
  'scienceInside.combo.point1': 'Moteur 1 : « Visible immédiatement » — hydratation, diffusion de la lumière, texture plus lisse',
  'scienceInside.combo.point2': 'Moteur 2 : « Visible avec le temps » — raffermissement, élasticité, réparation',
  'scienceInside.combo.point3': 'L’effet « waouh » immédiat vous motive à continuer — les peptides et le PDRN font le reste',
  'scienceInside.combo.point4': 'Le résultat : une peau dense, apaisée et lumineuse',
  'scienceInside.tagline': 'Les peptides construisent et renforcent. Le PDRN répare et apaise. Ensemble, ils offrent à votre peau un éclat immédiat et une régénération durable.',

  // Science Inside — Default
  'scienceInside.default.subtitle': 'La science derrière le PDRN — comment il transforme votre peau de l’intérieur',
  'scienceInside.default.tagline': 'Le PDRN active le mécanisme naturel de réparation de la peau, favorise la régénération cellulaire et une hydratation profonde dès la première utilisation.',

  // Default product FAQ
  'productContent.default.faq1.q': 'Qu’est-ce que le PDRN et comment agit-il ?',
  'productContent.default.faq1.a': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon. Il active le mécanisme naturel de réparation de la peau via le récepteur d’adénosine A2A, et favorise la régénération cellulaire, la production de collagène et une hydratation profonde.',
  'productContent.default.faq2.q': 'Ce produit convient-il aux peaux sensibles ?',
  'productContent.default.faq2.a': 'Oui ! Nos formules sont testées dermatologiquement, non testées sur les animaux, et sans parabènes, sulfates ni phtalates. Elles sont conçues pour être douces pour tous les types de peau, y compris les peaux sensibles.',
  'productContent.default.faq3.q': 'Combien de temps faut-il pour voir des résultats ?',
  'productContent.default.faq3.a': 'La plupart des utilisatrices constatent une hydratation améliorée et un éclat visible dès la première utilisation. Pour des résultats optimaux sur les ridules et la texture de la peau, une utilisation régulière de 4 à 8 semaines est recommandée.',

  // Science Inside — Masks
  'scienceInside.masks.subtitle': 'Comment trois ingrédients puissants agissent ensemble dans chaque masque en tissu',
  'scienceInside.masks.tagline': 'Le PDRN répare au niveau cellulaire. La vitamine B12 illumine. Le niacinamide renforce. 20 minutes — c’est tout ce dont votre peau a besoin pour tout absorber.',
  'scienceInside.masks.card1.title': 'PDRN + Vitamine B12 — le duo éclat',
  'scienceInside.masks.card1.subtitle': 'Réparation cellulaire rencontre éclat visible',
  'scienceInside.masks.card1.point1': 'Le PDRN active la régénération cellulaire tandis que la vitamine B12 offre un effet éclaircissant immédiat',
  'scienceInside.masks.card1.point2': 'Ensemble, ils traitent le teint terne à la source — pas seulement un éclat superficiel',
  'scienceInside.masks.card1.point3': 'La B12 est un actif reconnu qui unifie le teint au fil du temps',
  'scienceInside.masks.card1.point4': 'Le duo agit en synergie — le PDRN renouvelle, la B12 illumine',
  'scienceInside.masks.card2.title': 'Niacinamide — le bâtisseur de barrière',
  'scienceInside.masks.card2.subtitle': 'Renforce, équilibre, protège',
  'scienceInside.masks.card2.point1': 'Renforce la barrière cutanée pour retenir l’hydratation et bloquer les irritants',
  'scienceInside.masks.card2.point2': 'Réduit visiblement les pores et régule l’excès de sébum',
  'scienceInside.masks.card2.point3': 'Atténue les rougeurs et apaise les inflammations — idéal pour les peaux sensibles',
  'scienceInside.masks.card2.point4': 'Agit sur toutes les couches de la peau pour améliorer la texture, le teint et la résilience',
  'scienceInside.masks.card3.title': 'L’effet masque — 20 minutes d’absorption profonde',
  'scienceInside.masks.card3.subtitle': 'Pourquoi un masque en tissu est supérieur à un sérum classique',
  'scienceInside.masks.card3.point1': 'Le masque en tissu crée un environnement occlusif qui empêche l’évaporation',
  'scienceInside.masks.card3.point2': 'Les actifs sont délivrés en concentration plus élevée que les sérums quotidiens',
  'scienceInside.masks.card3.point3': 'Absorption profonde — les ingrédients pénètrent plus profondément grâce au contact prolongé avec la peau',
  'scienceInside.masks.card3.point4': 'Résultats immédiats et visibles : une peau plus rebondie, hydratée et éclatante dès la première utilisation',

  // Science Inside — Cream
  'scienceInside.cream.subtitle': 'Trois technologies avancées qui agissent la nuit pour transformer votre peau',
  'scienceInside.cream.tagline': 'Le collagène reconstruit la structure. Les céramides protègent la barrière. Les capsules intelligentes délivrent le tout pendant la nuit — pour que vous vous réveilliez avec une peau renouvelée et raffermie.',
  'scienceInside.cream.card1.title': 'Collagène hydrolysé — la structure',
  'scienceInside.cream.card1.subtitle': 'Reconstruction de l’intérieur vers l’extérieur',
  'scienceInside.cream.card1.point1': 'Fragmenté en petits morceaux capables de pénétrer véritablement dans la peau — pas seulement rester en surface',
  'scienceInside.cream.card1.point2': 'Soutient la matrice structurelle de la peau pour plus de fermeté et d’élasticité',
  'scienceInside.cream.card1.point3': 'Aide à réduire l’apparence des ridules en comblant de l’intérieur',
  'scienceInside.cream.card1.point4': 'Fonctionne avec la production naturelle de collagène de votre peau — renforcement, pas remplacement',
  'scienceInside.cream.card2.title': 'Complexe de céramides — le bouclier',
  'scienceInside.cream.card2.subtitle': 'La protection naturelle de votre peau, renforcée',
  'scienceInside.cream.card2.point1': 'Les céramides composent 50% de la barrière naturelle de la peau — nous compensons ce qui se perd avec l’âge',
  'scienceInside.cream.card2.point2': 'Retient l’hydratation jusqu’à 72 heures — fini la sensation de sécheresse et de tiraillement la nuit',
  'scienceInside.cream.card2.point3': 'Protège contre les agressions environnementales : pollution, air sec, variations de température',
  'scienceInside.cream.card2.point4': 'Renforce la barrière pour que les autres actifs agissent plus efficacement',
  'scienceInside.cream.card3.title': 'Technologie capsules intelligentes — libération progressive',
  'scienceInside.cream.card3.subtitle': 'Des actifs délivrés tout au long de la nuit',
  'scienceInside.cream.card3.point1': 'Des micro-capsules se décomposent progressivement et libèrent les actifs pendant 8 heures',
  'scienceInside.cream.card3.point2': 'Empêche la dégradation des ingrédients — ils restent puissants jusqu’au moment de leur libération',
  'scienceInside.cream.card3.point3': 'Votre peau reçoit un flux constant de nutrition au lieu d’une seule dose qui s’estompe',
  'scienceInside.cream.card3.point4': 'Réveillez-vous avec une peau renouvelée et hydratée — les capsules ont travaillé pendant votre sommeil',

  // Science Inside — Bundle
  'scienceInside.bundle.subtitle': 'Pourquoi trois produits ensemble offrent des résultats qu’aucun produit seul ne peut atteindre',
  'scienceInside.bundle.tagline': 'Les masques nettoient et nourrissent. Le sérum répare et illumine. La crème scelle le tout. Trois étapes, un seul système — 24 heures de transformation continue de la peau.',
  'scienceInside.bundle.card1.title': 'Trois étapes, un seul système',
  'scienceInside.bundle.card1.subtitle': 'Chaque produit prépare la peau pour l’étape suivante',
  'scienceInside.bundle.card1.point1': 'Étape 1 : les masques en tissu nettoient en profondeur et nourrissent avec du PDRN concentré + vitamine B12',
  'scienceInside.bundle.card1.point2': 'Étape 2 : le sérum répare, raffermit et offre l’effet Glass Skin',
  'scienceInside.bundle.card1.point3': 'Étape 3 : la crème scelle le tout avec du collagène, des céramides et des capsules à libération progressive',
  'scienceInside.bundle.card1.point4': 'Ensemble : une routine complète où chaque étape renforce la précédente',
  'scienceInside.bundle.card2.title': 'L’effet synergie — meilleur ensemble',
  'scienceInside.bundle.card2.subtitle': 'Des résultats cumulatifs qui s’amplifient avec le temps',
  'scienceInside.bundle.card2.point1': 'L’utilisation des trois produits crée un effet cumulatif — les résultats se construisent les uns sur les autres',
  'scienceInside.bundle.card2.point2': 'Du PDRN à chaque étape signifie une régénération cellulaire constante tout au long de la routine',
  'scienceInside.bundle.card2.point3': 'Différents modes d’application (masque, sérum, crème) garantissent que les actifs atteignent toutes les couches de la peau',
  'scienceInside.bundle.card2.point4': 'Les clientes rapportent des résultats significativement plus rapides avec la routine complète',
  'scienceInside.bundle.card3.title': 'Couverture 24 heures — jour et nuit',
  'scienceInside.bundle.card3.subtitle': 'Votre peau n’est jamais laissée sans protection',
  'scienceInside.bundle.card3.point1': 'Matin : sérum sous le maquillage pour hydratation, protection et éclat toute la journée',
  'scienceInside.bundle.card3.point2': 'Soir : masque en tissu pour un nettoyage profond et une nutrition (2-3 fois par semaine)',
  'scienceInside.bundle.card3.point3': 'Nuit : crème avec capsules à libération progressive qui agissent pendant votre sommeil',
  'scienceInside.bundle.card3.point4': 'Le résultat : une régénération en continu — votre peau s’améliore 24h/24',

  // What is PDRN
  'whatIsPDRN.title': 'Qu’est-ce que le PDRN ?',
  'whatIsPDRN.subtitle': 'L’ingrédient révolutionnaire qui transforme le monde des soins — de la clinique à chez vous',
  'whatIsPDRN.origin.title': 'Extrait du DNA de saumon',
  'whatIsPDRN.origin.subtitle': 'Un ingrédient prouvé en médecine esthétique',
  'whatIsPDRN.origin.point1': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie à travers le monde',
  'whatIsPDRN.origin.point1.US': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie aux États-Unis',
  'whatIsPDRN.origin.point1.GB': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie au Royaume-Uni',
  'whatIsPDRN.origin.point1.AU': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie en Australie',
  'whatIsPDRN.origin.point1.IL': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie en Israël',
  'whatIsPDRN.origin.point1.FR': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie à travers la France',
  'whatIsPDRN.origin.point1.DE': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie à travers l\'Allemagne',
  'whatIsPDRN.origin.point1.ES': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie à travers l\'Espagne',
  'whatIsPDRN.origin.point1.NO': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie à travers la Norvège',
  'whatIsPDRN.origin.point1.HR': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie à travers la Croatie',
  'whatIsPDRN.origin.point1.FI': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie à travers la Finlande',
  'whatIsPDRN.origin.point1.AE': 'Le PDRN (polydésoxyribonucléotide) est extrait du DNA de saumon — une molécule biocompatible utilisée dans les cliniques de dermatologie aux Émirats arabes unis',
  'whatIsPDRN.origin.point2': 'Étayé par des études cliniques avec des résultats mesurables en hydratation et élasticité',
  'whatIsPDRN.origin.point3': 'Composé régénératif naturel — sans agents de comblement synthétiques, sans produits chimiques agressifs',
  'whatIsPDRN.howItWorks.title': 'Régénération au niveau cellulaire',
  'whatIsPDRN.howItWorks.subtitle': 'Agit là où les autres produits ne vont pas',
  'whatIsPDRN.howItWorks.point1': 'Active le récepteur d’adénosine A2A — déclenche le processus naturel de réparation et de régénération de votre peau',
  'whatIsPDRN.howItWorks.point2': 'Stimule la production de collagène et d’élastine de l’intérieur, pas seulement une hydratation superficielle',
  'whatIsPDRN.howItWorks.point3': 'Réduit les inflammations et apaise les peaux stressées pour une peau plus saine et équilibrée',
  'whatIsPDRN.results.title': 'Des résultats de niveau clinique chez vous',
  'whatIsPDRN.results.subtitle': 'Jusqu’à récemment — uniquement en clinique',
  'whatIsPDRN.results.point1': 'Jusqu’à récemment, les traitements PDRN n’étaient disponibles que dans des cliniques de dermatologie haut de gamme à des prix élevés',
  'whatIsPDRN.results.point2': 'Nos formules délivrent le même actif dans un format d’utilisation quotidienne que vous pouvez appliquer chez vous',
  'whatIsPDRN.results.point3': '+100% d’amélioration de l’hydratation mesurée cliniquement — amélioration visible dès la première application',

  // Proven Results
  'provenResults.title': 'Résultats prouvés',
  'provenResults.stat1.value': '+100%',
  'provenResults.stat1.label': 'Amélioration de l’hydratation',
  'provenResults.stat1.sub': 'Mesuré cliniquement',
  'provenResults.stat2.value': '93%',
  'provenResults.stat2.label': 'Peau plus lisse',
  'provenResults.stat2.sub': 'Rapporté en 4 semaines',
  'provenResults.stat3.value': '4.9/5',
  'provenResults.stat3.label': 'Note des clientes',
  'provenResults.stat3.sub': 'Moyenne sur tous les produits',
  'provenResults.stat4.value': '+10 000',
  'provenResults.stat4.label': 'Clientes satisfaites',
  'provenResults.stat4.sub': 'Dans le monde entier',
  'provenResults.stat4.sub.US': 'Partout aux États-Unis',
  'provenResults.stat4.sub.GB': 'Partout au Royaume-Uni',
  'provenResults.stat4.sub.AU': 'Partout en Australie',
  'provenResults.stat4.sub.IL': 'Partout en Israël',
  'provenResults.stat4.sub.FR': 'Partout en France',
  'provenResults.stat4.sub.DE': 'Partout en Allemagne',
  'provenResults.stat4.sub.ES': 'Partout en Espagne',
  'provenResults.stat4.sub.NO': 'Partout en Norvège',
  'provenResults.stat4.sub.HR': 'Partout en Croatie',
  'provenResults.stat4.sub.FI': 'Partout en Finlande',
  'provenResults.stat4.sub.AE': 'Partout aux Émirats arabes unis',

  // Comparison Table
  'comparison.title': 'PDRN vs soins classiques',
  'comparison.headerRegular': 'Soins classiques',
  'comparison.headerPDRN': 'PDRN SKIN',
  'comparison.row1.criteria': 'Action',
  'comparison.row1.regular': 'Hydratation superficielle',
  'comparison.row1.pdrn': 'Régénération au niveau cellulaire',
  'comparison.row2.criteria': 'Actif principal',
  'comparison.row2.regular': 'Peptides génériques',
  'comparison.row2.pdrn': 'PDRN (DNA de saumon)',
  'comparison.row3.criteria': 'Résultats',
  'comparison.row3.regular': 'Semaines avant d’être visibles',
  'comparison.row3.pdrn': 'Visible dès la première utilisation',
  'comparison.row4.criteria': 'Technologie',
  'comparison.row4.regular': 'Formules standard',
  'comparison.row4.pdrn': 'Technologie de niveau clinique',
  'comparison.row5.criteria': 'Preuve clinique',
  'comparison.row5.regular': 'Allégations marketing',
  'comparison.row5.pdrn': 'Testé cliniquement +100% hydratation',

  // FAQ
  'faq.sectionTitle': 'Questions fréquentes',

  // 404
  '404.title': 'Page introuvable',
  '404.subtitle': 'La page que vous recherchez n’existe pas ou a été déplacée.',
  '404.backHome': 'Retour à l’accueil',
  '404.popularProducts': 'Produits populaires',

  // Product disclaimer and shipping
  'product.disclaimer': '*Les images sont fournies à titre indicatif uniquement. Les résultats peuvent varier d’une personne à l’autre en fonction du type de peau et de l’utilisation. Ce produit n’est pas destiné à diagnostiquer, traiter ou prévenir des conditions médicales. Il est recommandé d’effectuer un test de sensibilité sur une zone discrète avant la première utilisation complète. En cas de sensibilité, cessez l’utilisation. En cas de réaction sévère, consultez un médecin. Le fournisseur peut modifier l’emballage et la forme du produit de temps à autre ; le produit reste identique.',
  'product.shippingMarquee': 'Livraison gratuite pour les commandes de plus de {amount} en France',
  'product.inStockReady': 'En stock, prêt pour expédition immédiate',

  // Terms agreement
  'product.termsAgreementBefore': 'En naviguant et en achetant sur ce site, vous acceptez nos ',
  'product.termsLink': 'conditions générales',
  'product.termsAgreementAfter': '',

  // Announcement
  'announcement.freeShipping': '✨ livraison gratuite pour les commandes de plus de {amount} en France',
  'announcement.close': 'Fermer',

  // Urgency
  'urgency.limitedOffer': 'Offre limitée',
  'urgency.endsIn': 'Se termine dans',

  // Blog
  'blog.title': 'Blog',
  'blog.subtitle': 'Guides de soins professionnels, science du PDRN et conseils de la beauté coréenne',
  'blog.metaDescription': 'Lisez nos guides professionnels sur les soins PDRN, la science du DNA de saumon, les routines Glass Skin et les conseils de la beauté coréenne.',
  'blog.readMore': 'Lire la suite',
  'blog.minRead': 'min de lecture',
  'blog.badge': 'Soins scientifiquement prouvés',
  'blog.chip.antiAging': 'Anti-âge',
  'blog.chip.hydration': 'Hydratation',
  'blog.chip.sensitiveSkin': 'Peau sensible',
  'blog.chip.nightRoutine': 'Routine du soir',
  'blog.chip.ingredients': 'Ingrédients',
  'blog.chip.layering': 'Layering',
  'blog.chip.glassSkin': 'Glass Skin',
  'blog.chip.pdrnScience': 'Science du PDRN',
  'blog.relatedArticles': 'Articles liés',
  'blog.recommendedProducts': 'Produits recommandés',
  'blog.latestArticles': 'Les derniers articles de notre blog',
  'blog.latestSubtitle': 'Guides professionnels de soins PDRN et conseils de la beauté coréenne',
  'blog.viewAll': 'Voir tous les articles',
  'blog.statsArticles': 'Articles',
  'blog.statsLanguages': 'Langues',
  'blog.statsVersions': 'Versions traduites',
  'blog.availableIn': 'Disponible en 11 langues',
  'blog.avgReadTime': 'Moy. 5 min de lecture',

  // SEO meta (homepage)
  'seo.homeTitle': 'PDRN Soins de la Peau | Sérum ADN de Saumon Coréen, Masques & Crème | Glass Skin',
  'seo.homeDescription': 'Soins PDRN à base d\'ADN de saumon coréen. Sérum PDRN, masques en tissu & crème capsule pour l\'effet Glass Skin. Cliniquement prouvé avec livraison gratuite.',

  // SEO product titles & descriptions
  'seo.productTitle.pink-glow-serum-with-pdrn-peptides': 'Sérum PDRN à l\'ADN de Saumon & Peptides | Soins PDRN',
  'seo.productDescription.pink-glow-serum-with-pdrn-peptides': 'Achetez le sérum PDRN à l\'ADN de saumon et peptides. Sérum coréen Glass Skin pour stimuler le collagène et lisser les rides. Soins PDRN avec livraison gratuite.',
  'seo.productTitle.pdrn-pink-sheet-masks-10-pack': 'Masques PDRN en Tissu x10 | Masques Coréens ADN de Saumon | Soins PDRN',
  'seo.productDescription.pdrn-pink-sheet-masks-10-pack': 'Achetez les masques en tissu PDRN imbibés de sérum ADN de saumon. 10 masques coréens pour l\'effet Glass Skin avec PDRN, Vitamine B12 & Niacinamide.',
  'seo.productTitle.smart-capsule-cream-with-collagen': 'Crème Capsule PDRN au Collagène | Soins Coréens | Soins PDRN',
  'seo.productDescription.smart-capsule-cream-with-collagen': 'Achetez la crème capsule PDRN au collagène et niacinamide. Crème anti-âge coréenne à l\'ADN de saumon pour hydratation profonde et fermeté.',
  'seo.productTitle.complete-pdrn-trio-bundle': 'Coffret Complet PDRN — Sérum, Masques & Crème | Soins PDRN',
  'seo.productDescription.complete-pdrn-trio-bundle': 'Achetez le coffret complet de soins PDRN avec sérum, 10 masques & crème capsule. Économisez jusqu\'à 53% sur les soins coréens ADN de saumon.',

  // Internal linking
  'seo.explorePDRN': 'Découvrir les soins PDRN',
  'seo.anchor.serumBenefits': 'Bienfaits du sérum PDRN',
  'seo.anchor.howPDRNWorks': 'Comment fonctionne le PDRN',
  'seo.anchor.masksVsTraditional': 'Masques PDRN vs traditionnels',
  'seo.anchor.glassSkinGuide': 'Guide Glass Skin',
  'seo.anchor.koreanSecret': 'Le secret coréen du soin',
  'seo.anchor.pdrnVsRegular': 'PDRN vs soins classiques',
};
